export default "__VITE_ASSET__OT_K$F8o4heI5qTaR0c68w__"